module.exports = __webpack_public_path__ + "img/violet_082.a4f28486.png";